import { useState, useEffect } from "react";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Paper from "@mui/material/Paper";
import Icon from "@mui/material/Icon";
import { useNavigate, useLocation } from "react-router-dom";

const tabs = [
  { label: "Home", icon: "dashboard", path: "/dashboard" },
  { label: "Schedules", icon: "event_note", path: "/my_schedules" },
  { label: "Builder", icon: "edit_calendar", path: "/schedule-builder" },
  { label: "Cookbook", icon: "auto_stories", path: "/cookbook" },
  { label: "Kitchen", icon: "local_fire_department", path: "/your-kitchen" },
];

function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const pathnameIndex = tabs.findIndex((t) => pathname.startsWith(t.path));
  const [selected, setSelected] = useState(pathnameIndex === -1 ? false : pathnameIndex);

  useEffect(() => {
    setSelected(pathnameIndex === -1 ? false : pathnameIndex);
  }, [pathnameIndex]);

  return (
    <Paper
      elevation={4}
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        display: { xs: "block", xl: "none" },
        zIndex: 1200,
        pb: "env(safe-area-inset-bottom)",
        backgroundColor: "#f5f5f5",
        borderTop: "2px solid #a01c27",
      }}
    >
      <BottomNavigation
        showLabels
        value={selected}
        onChange={(_, newValue) => {
          setSelected(newValue);
          navigate(tabs[newValue].path, { replace: true });
        }}
        sx={{
          height: 68,
          backgroundColor: "#f5f5f5",
          "& .MuiBottomNavigationAction-root": { fontSize: "0.7rem", gap: "2px" },
          "& .MuiBottomNavigationAction-root .MuiIcon-root": { fontSize: "1.6rem !important" },
          "& .Mui-selected": { color: "#a01c27" },
          "& .Mui-selected .MuiIcon-root": { color: "#a01c27" },
        }}
      >
        {tabs.map((t) => (
          <BottomNavigationAction key={t.path} label={t.label} icon={<Icon>{t.icon}</Icon>} />
        ))}
      </BottomNavigation>
    </Paper>
  );
}

export default BottomNav;
